import { useEffect, useState, type RefObject } from "react";
import {
  CALL_MINI_IFRAME_REF_HEIGHT,
  CALL_MINI_IFRAME_REF_WIDTH,
} from "../lib/board/callAppUrl";

export function useCallMiniIframeScale(
  enabled: boolean,
  shellRef: RefObject<HTMLElement | null>
): {
  scale: number;
  refWidth: number;
  refHeight: number;
} {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    if (!enabled) {
      setScale(1);
      return;
    }

    const shell = shellRef.current;
    if (!shell) return;

    const body = shell.querySelector<HTMLElement>(".wb-board-call-shell__body");
    if (!body) return;

    const sync = (width: number, height: number) => {
      if (width < 8 || height < 8) return;
      const raw = Math.min(
        width / CALL_MINI_IFRAME_REF_WIDTH,
        height / CALL_MINI_IFRAME_REF_HEIGHT
      );
      setScale(Math.min(raw, 1));
    };

    const ro = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;
      sync(entry.contentRect.width, entry.contentRect.height);
    });

    ro.observe(body);
    sync(body.clientWidth, body.clientHeight);
    return () => ro.disconnect();
  }, [enabled, shellRef]);

  return {
    scale,
    refWidth: CALL_MINI_IFRAME_REF_WIDTH,
    refHeight: CALL_MINI_IFRAME_REF_HEIGHT,
  };
}
